import axiosHttp from "services/axiosHttp";
const { createSlice, createAsyncThunk } = require("@reduxjs/toolkit");

//action
export const fetchRewardProductInfo = createAsyncThunk("fetchRewardProductInfo", async (id) => {
	const response = await axiosHttp.get(`product/${id}`);
	return response.data.data;
});

const RewardProductInfoSlice = createSlice({
	name: "RewardProductListSlice",
	initialState: {
		isLoading: false,
		data: null,
		error: null,
	},

	extraReducers: (builder) => {
		builder.addCase(fetchRewardProductInfo.pending, (state) => {
			state.isLoading = true;
		});

		builder.addCase(fetchRewardProductInfo.fulfilled, (state, action) => {
			state.isLoading = false;
			state.data = action.payload;
		});
		builder.addCase(fetchRewardProductInfo.rejected, (state, action) => {
			state.isLoading = false;
			state.error = action.payload;
		});
	},
});

export default RewardProductInfoSlice.reducer;
